export default __webpack_public_path__ + "static/media/atoirSlide.ceefe0f6.png";